import { useCallback, useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { useLocation } from "react-router-dom";

import {
  getQueryFromUrl,
  updateQueryParam,
} from "@utils/helpers/getQueryFromUrl";
import { getMyInfo, refreshToken, signOut, useAppDispatch } from "@lib/stores";
import { AuthActions } from "@lib/stores/auth/slices";
import { useAppNavigate } from "@utils/hooks/useAppNavigate";
import {
  getStorageSync,
  removeStorageSync,
  setStorageSync,
} from "@modules/storage/storageHelper";

export const SubscribedAutoLogin = () => {
  const token = getQueryFromUrl("token");
  const refreshTokenParam = getQueryFromUrl("refresh");

  const navigate = useAppNavigate();

  const dispatch = useAppDispatch();

  const [autoAuthenticate, setAutoAuthenticate] = useState(false);

  const authenticated = getStorageSync("TOKEN")?.token;

  const { search } = useLocation();

  const onFailure = useCallback(() => {
    console.log("failed auto authentication");

    navigate("/login");

    removeStorageSync("AUTO_AUTHENTICATED");
  }, [navigate]);

  const signOutHandler = async () => {
    await signOut();
  };

  useEffect(() => {
    if (authenticated && !autoAuthenticate) {
      signOutHandler();
    } else if (!authenticated && !autoAuthenticate) {
      setStorageSync({ key: "AUTO_AUTHENTICATED", data: false });

      setAutoAuthenticate(true);
    }
  }, [search, authenticated, autoAuthenticate]);

  useEffect(() => {
    if (token && autoAuthenticate) {
      getMyInfo(
        { token: decodeURIComponent(token) },
        () => {
          if (refreshTokenParam) {
            refreshToken(
              {
                token: decodeURIComponent(token),
                refreshToken: decodeURIComponent(refreshTokenParam),
              },
              () => {
                updateQueryParam("forceAuthenticate", "false");

                setStorageSync({ key: "AUTO_AUTHENTICATED", data: true });

                dispatch(AuthActions.loadAuthAsync());
              },
              onFailure
            );
          }
        },
        onFailure
      );
    } else if (!token && autoAuthenticate) {
      onFailure();
    }
  }, [token, refreshTokenParam, dispatch, onFailure, autoAuthenticate]);

  return (
    <div className="flex w-full items-center justify-center pt-20">
      <Loader2
        className={`animate-spin text-white`}
        size={100}
        strokeWidth={1}
      />
    </div>
  );
};
